module.exports = __webpack_public_path__ + "img/changeProfile-2.01e964f.png";